import clsx from 'clsx'
import {FC, useEffect} from 'react'
import {Outlet, useLocation} from 'react-router'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {MenuComponent} from '../assets/ts/components'
import {ThemeModeProvider} from '../partials/layout/theme-mode/ThemeModeProvider'

const MasterLayout = () => {
  const appTitle = process.env.REACT_APP_TITLE?.toLowerCase()
  const isDsos = appTitle === 'dsos'
  const pageClasses = clsx('page d-flex flex-column-fluid', {
    'flex-row': !isDsos,
    'flex-column flex-lg-row': isDsos,
  })
  const location = useLocation()
  const isCbbeeRoute = location.pathname === '/cbbee' || location.pathname.startsWith('/cbbee/')

  useEffect(() => {
    const timer = setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
    return () => clearTimeout(timer)
  }, [location.key])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root'>
          <div className={pageClasses}>
            {!isCbbeeRoute && <AsideDefault hideMenuContent={isDsos} />}
            <div
              className={clsx('wrapper d-flex flex-column flex-row-fluid', {
                'cbbee-wrapper': isCbbeeRoute,
              })}
              id='kt_wrapper'
            >
              {!isCbbeeRoute && <HeaderWrapper />}

              <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
                <Content>
                  {isDsos && <DsosNotice />}
                  <Outlet />
                </Content>
              </div>
              {!isCbbeeRoute && <Footer />}
            </div>
          </div>
        </div>

        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

const DsosNoticeMessage: FC = () => (
  <>
    <span className='fs-5 fs-lg-4 fw-bold text-primary mb-3 mb-lg-4'>Bilgilendirme</span>
    <p className='fs-7 fs-lg-6 text-gray-700 mb-0'>
      Bu uygulamadan yalnızca sınav ve dersliklerin organizasyonu ile ilgili işlemler
      yapılabilmektedir. Ölçme ve değerlendirme sistemi, Anket sistemi ve diğer kalite süreçleri
      için Yükseköğretimde Kalite Yönetim Sistemi'ne giriş yapmalısınız.
    </p>
  </>
)

const DsosNotice: FC = () => {
  return (
    <div className='d-flex flex-column flex-lg-row gap-3 gap-lg-5 align-items-start align-items-lg-center text-center text-lg-start px-5 py-5 mb-6 bg-light border border-dashed border-primary border-2 rounded-3'>
      <DsosNoticeMessage />
    </div>
  )
}

export {MasterLayout}
